import useAppSelector from '@/features/app/hooks/useAppSelector';
import useFeatureFlags from '@/features/feature-flags/hooks/useFeatureFlags';
import useSyncPushDeviceMutation from '@/features/push/mutations/useSyncPushDeviceMutation';
import useNotificationSettingsQuery from '@/features/user/queries/useNotificationSettingsQuery';
import { useEffect } from 'react';

export default function usePushDeviceSync() {
  const user = useAppSelector((state) => state.auth.user);
  const initialized = useAppSelector((state) => state.auth.initialized);
  const featureFlags = useFeatureFlags();
  const { data: notificationSettings } = useNotificationSettingsQuery();
  const { mutate: syncPushDevice } = useSyncPushDeviceMutation();

  useEffect(() => {
    if (!featureFlags.push.enabled || !initialized || !user || !notificationSettings) return;
    syncPushDevice();
  }, [featureFlags.push.enabled, initialized, notificationSettings, syncPushDevice, user]);
}
